import { render, staticRenderFns } from "./Journals.vue?vue&type=template&id=9f6b64fa&scoped=true"
import script from "./Journals.vue?vue&type=script&lang=js"
export * from "./Journals.vue?vue&type=script&lang=js"
import style0 from "./Journals.vue?vue&type=style&index=0&id=9f6b64fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6b64fa",
  null
  
)

export default component.exports